import { NgModule } from '@angular/core';
import { MainRoutingModule } from './main-routing.module';
import { UserService } from '../services/UserService';
import { ProductService } from '../services/ProductService';
import { ProductReleaseService } from '../services/ProductReleaseService';
import { PagerService } from '../services/PagerService';
import { PageLayoutsModule } from '../page-layouts/page-layouts.module';
import { AzureDownloadService } from '../extra-pages/DownloadSCAL360/AzureDownloadService.service';




@NgModule({
    imports: [
        MainRoutingModule,        
        PageLayoutsModule        
    ],
    declarations: [],

    providers: [UserService,
                ProductService,
                ProductReleaseService,                 
                PagerService,
                AzureDownloadService
               ]
})

export class MainModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/main.module.ts